import { Directive, ElementRef, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import interact from 'interactjs';

import { ReplaySubject, Subscription } from 'rxjs';

@Directive({
	selector: '[interactDraggable]'
})

export class InteractDraggableDirective implements OnInit, OnDestroy {
	@Input() interactOptions: any;
	@Input() disableDrag: boolean;
	@Input() interactSnapObjectSubject: ReplaySubject<any>;
	@Output() interactDragStart: EventEmitter<any> = new EventEmitter<any>();
	@Output() interactDragging: EventEmitter<any> = new EventEmitter<any>();
	@Output() interactDragEnd: EventEmitter<any> = new EventEmitter<any>();

	private interactable: interact.Interactable;
	private interactSnapObjectSubscription: Subscription;

	constructor(private el: ElementRef) {
		this.interactable = interact(this.el.nativeElement);
	}

	ngOnInit() {
		if (this.interactSnapObjectSubject) {
			this.interactSnapObjectSubscription = this.interactSnapObjectSubject.subscribe((snapObject: any) => {
				if (!this.disableDrag) {
					this.interactable.draggable(this.createInteractObject(snapObject));
				} else {
					return;
				}
			});
		} else {
			this.interactable.draggable(this.createInteractObject({}));
		}
	}

	ngOnDestroy() {
		if (this.interactSnapObjectSubscription) {
			this.interactSnapObjectSubscription.unsubscribe();
		}
	}

	private createInteractObject(snapObject: any): any {
		const obj: any = {
			restrict: {
				restriction: 'parent',
				elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
			},
			snap: snapObject,
			onstart: (event: interact.InteractEvent) => {
				if (!this.disableDrag) {
					event.interaction.x = parseInt(event.target.style.left, 10) || 0;
					event.interaction.y = parseInt(event.target.style.top, 10) || 0;

					this.interactDragStart.emit({
						left: event.interaction.x,
						top: event.interaction.y
					});
				}

			},
			onmove: (event: interact.InteractEvent) => {
				if (!this.disableDrag) {
					event.interaction.x += event.dx;
					event.interaction.y += event.dy;
					event.target.style.left = event.interaction.x + 'px';
					event.target.style.top = event.interaction.y + 'px';
					this.interactDragging.emit({
						left: event.interaction.x,
						top: event.interaction.y
					});
				}
			},
			onend: (event: interact.InteractEvent) => {
				if (!this.disableDrag) {
					event.target.setAttribute('data-x', event.interaction.x);
					event.target.setAttribute('data-y', event.interaction.y);

					this.interactDragEnd.emit({
						left: event.interaction.x,
						top: event.interaction.y
					});
				}
			},
		};
		if (this.interactOptions) {
			return Object.assign(obj, this.interactOptions);
		}
		return obj;
	}
}
